import ManagedLookup from '../components/ManagedLookup';
import fields from './fields';
import useLookupPage from '../hooks/useLookupPage';
import columns from './columns';

const Commodities = ({ definition }) => {
    const page = useLookupPage('commodities', columns);
    return <ManagedLookup definition={definition} columns={columns} fields={fields} page={page} />;
};

export default Commodities;
